module.exports = __webpack_public_path__ + "static/media/abduallah.640ed3ba.jpeg";